/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo, useCallback } from 'react';
import { Form, Anchor } from 'antd';

import SwitchPlatform from './components/SwitchPlatform';

import DsRequestPreview from './DSForm/DsRequestPreview';
import ThankYouPage from './ThankYouPage';
import { useDsRequestContext } from '../context';
import useQuery from '../../../util/useQuery';
import { useTranslation } from 'react-i18next';
import GlobalService from '../../../services/Global.service';
import Rights from './Rights';

const Preview = ({ values, domainSelection, loading, requestType, form }) => {
    const params = useQuery();
    const UIContext = useDsRequestContext();
    const UIProps = useMemo(() => {
        return {
            logo: UIContext.logo,
            value: UIContext.value,
            setValue: UIContext.setValue,
            previewLang: UIContext.previewLang,
            setPreviewLang: UIContext.setPreviewLang,
            companyId: UIContext.companyId,
        };
    }, [UIContext]);
    const { t } = useTranslation();

    const [customize, setCustomize] = useState();
    const [selectedTab, setSelectedTab] = useState(params.get('tab'));

    useEffect(() => {
        setCustomize(values);
        getCustomForm(values);
    }, [values]);

    useEffect(() => {
        setSelectedTab(params.get('tab'));
    }, [params]);

    const [platform, setPlatform] = useState('Desktop');
    const [submitData, setSubmitData] = useState({});
    //Customize
    const [policyAndTermsOfService, setPolicyAndTermsOfService] = useState();
    const [customForm, setCustomForm] = useState();
    const [customStyle, setCustomStyle] = useState();
    const [fontStyle, setFontStyle] = useState();
    const [personalTypeList, setPersonalTypeList] = useState();
    const [logo, setLogo] = useState();
    const [companyLogo, setCompanyLogo] = useState();

    const [dataSubjectType, setDataSubjectType] = useState([]);

    const getDs = async () => {
        try {
            const { data } = await GlobalService.getDs();
            if (data?.resultData) {
                setDataSubjectType(data?.resultData?.dataSubjectType);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getDs();
    }, []);

    const getPersonalType = useCallback(
        async (values) => {
            try {
                const items = [];
                const itemsAddOn = [];
                values?.dataSubjectType?.forEach((item) => {
                    dataSubjectType?.filter((res, index) => {
                        if (res?.id === item) {
                            const data = {
                                index: index,
                                ...res,
                                name:
                                    UIProps.previewLang === 'EN'
                                        ? res.nameEn
                                        : res.nameTh,
                            };
                            items.push(data);
                        }
                    });
                });
                if (values?.dataSubjectTypeAddOn) {
                    values?.dataSubjectTypeAddOn.map((res) => {
                        itemsAddOn.push({ name: res.dataSubjectAddOnName });
                    });
                }
                items.sort((a, b) => a.index - b.index);
                const result = items.concat(itemsAddOn);
                setPersonalTypeList(result);
            } catch (error) {
                console.log(error);
            }
        },
        [dataSubjectType, UIProps.previewLang]
    );

    useEffect(() => {
        setCompanyLogo(UIProps.logo);
    }, [UIProps.logo]);

    // form
    const [applicantInformation] = Form.useForm();
    const [personalInformation] = Form.useForm();
    const [detailsOfClaim] = Form.useForm();
    const [evidenceInformation] = Form.useForm();

    const getCustomForm = (item) => {
        const values = {
            domainId: item?.domainId,
            updateDate: item?.updateDate,
            updateByFullname: item?.updateByFullname,
            ...item?.customizeForm,
            // dataSubjectType: item?.dataSubjectType,
            // dataSubjectTypeAddOn: item?.dataSubjectTypeAddOn,
            // customizeStyle: item?.customizeStyle,
            customizeStyle: {
                mainColor: item?.customizeStyle?.mainColor,
                bgColor: item?.customizeStyle?.bgColor,
                buttonColor: item?.customizeStyle?.buttonColor,
            },
            fontStyle: {
                ...item?.fontStyle,
                fontSize: item?.fontStyle?.fontSize,
                fontFamily: item?.fontStyle?.fontFamily?.toLowerCase(),
            },
            logo: item?.logo,
            isUsedInventory: item?.isUsedInventory,
            thankyou: {
                topic: item?.thankyou?.topic,
                detail: item?.thankyou?.detail,
            },
        };
        getPersonalType(values);
        setCustomForm(values);
        setCustomStyle(item?.customizeStyle);
        setFontStyle(item?.fontStyle);
        setLogo(item?.logo);
        setPolicyAndTermsOfService(
            item?.customizeForm?.policyAndTermsOfService
        );
    };

    const [reset, setReset] = useState(true);

    useEffect(() => {
        applicantInformation?.resetFields();
        personalInformation?.resetFields();
        detailsOfClaim?.resetFields();
        evidenceInformation?.resetFields();

        setReset(false);
    }, [selectedTab, domainSelection, platform]);

    const PreviewPage = () => {
        const dsRequestPreview = (
            <DsRequestPreview
                requestType={requestType}
                platform={platform}
                value={customize}
                submitData={submitData}
                setSubmitData={setSubmitData}
                applicantInformation={applicantInformation}
                personalInformation={personalInformation}
                detailsOfClaim={detailsOfClaim}
                evidenceInformation={evidenceInformation}
                policyAndTermsOfService={policyAndTermsOfService}
                customForm={customForm}
                customStyle={customStyle}
                fontStyle={fontStyle}
                personalTypeList={personalTypeList}
                logo={logo}
                companyLogo={companyLogo}
                lang={UIProps.previewLang}
                reset={reset}
                setReset={setReset}
            />
        );
        if (selectedTab === '1') return dsRequestPreview;
        if (selectedTab === '2')
            return (
                <Rights
                    form={form}
                    platform={platform}
                    fontStyle={fontStyle}
                    lang={UIProps.previewLang}
                    requestType={requestType}
                />
            );
        if (selectedTab === '3')
            return <ThankYouPage customForm={customForm} />;
        return dsRequestPreview;
    };

    return (
        <div className="col-span-3">
            <Anchor className="bg-white p-4 mt-4 rounded-md h-max">
                <div className="space-y-3 relative">
                    <SwitchPlatform
                        loading={loading}
                        setPlatform={setPlatform}
                        platform={platform}
                    />
                    <div style={{ borderBottom: '1px solid #DBDBDB' }}></div>
                    <div className={`flex space-x-2 text-tiny`}>
                        <button
                            type="button"
                            style={{ borderRight: '1px solid #DBDBDB' }}
                            onClick={() => {
                                UIProps.setPreviewLang('TH');
                            }}
                            className={`${
                                UIProps.previewLang === 'TH'
                                    ? 'text-purple-PHX font-semibold'
                                    : ''
                            } cursor-pointer hover:opacity-80 pr-2`}
                        >
                            {t('Thai')}
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                UIProps.setPreviewLang('EN');
                            }}
                            className={`${
                                UIProps.previewLang === 'EN'
                                    ? 'text-purple-PHX font-semibold'
                                    : ''
                            } cursor-pointer hover:opacity-80`}
                        >
                            {t('English')}
                        </button>
                    </div>
                    <div style={{ borderBottom: '1px solid #DBDBDB' }}></div>
                    <div className="font-semibold">{t('Preview')}</div>
                    <div className=" relative preview">
                        {platform === 'Desktop' && (
                            <div className="device device-desktop">
                                <div className="flex space-x-2 pl-1 pb-4">
                                    <div>
                                        <svg
                                            width="13"
                                            height="14"
                                            viewBox="0 0 13 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="6.35041"
                                                cy="6.90705"
                                                r="6.17853"
                                                fill="#F64E60"
                                            />
                                        </svg>
                                    </div>
                                    <div>
                                        <svg
                                            width="13"
                                            height="14"
                                            viewBox="0 0 13 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="6.35041"
                                                cy="6.90705"
                                                r="6.17853"
                                                fill="#FCE697"
                                            />
                                        </svg>
                                    </div>
                                    <div>
                                        <svg
                                            width="13"
                                            height="14"
                                            viewBox="0 0 13 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="6.35041"
                                                cy="6.90705"
                                                r="6.17853"
                                                fill="#0BB783"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        borderRadius: '13.3071px',
                                        border: '2px solid #F3F3F6',
                                        backgroundColor:
                                            customize?.customizeStyle
                                                ?.mainColor,
                                    }}
                                    className="overflow-auto w-full h-md"
                                >
                                    <PreviewPage />
                                </div>
                            </div>
                        )}
                        {platform === 'Tablet' && (
                            <div className="device device-tablet-p shadow-xl">
                                <div
                                    style={{
                                        borderRadius: '13.3071px',
                                        border: '2px solid #F3F3F6',
                                        backgroundColor:
                                            customize?.customizeStyle
                                                ?.mainColor,
                                    }}
                                    className="overflow-auto w-full h-[1000px]"
                                >
                                    <PreviewPage />
                                </div>
                            </div>
                        )}
                        {platform === 'Mobile' && (
                            <div className="device device-mobile-p shadow-xl">
                                <div
                                    style={{
                                        borderRadius: '13.3071px',
                                        border: '2px solid #F3F3F6',
                                        backgroundColor:
                                            customize?.customizeStyle
                                                ?.mainColor,
                                    }}
                                    className="overflow-auto w-full h-[770px]"
                                >
                                    <PreviewPage />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Anchor>
        </div>
    );
};

export default Preview;
